<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Compare Records</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <!-- datepicker 2 -->
          <v-col cols="4">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  outlined
                  single-line
                  v-model="record.StartDate"
                  label="From"
                  prepend-icon="mdi-calendar-month"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
            </v-menu>
          </v-col>

          <!-- datepicker 2 -->
          <v-col cols="4">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  outlined
                  single-line
                  v-model="record.EndDate"
                  label="To"
                  prepend-icon="mdi-calendar-month"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="4">
            <v-btn color="primary" @click="queryData" :loading="loader">Query Data</v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-text-field
            name="compareSearch"
            outlined
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="auditData"
              :search="search"
            >
              <!-- action template -->
              <template v-slot:item.purchased="{ item }">
                <v-btn color="primary" @click="purchaseDialog(item)" text icon>Purchased</v-btn>
              </template>
              <!-- end -->
              <!-- action template -->
              <template v-slot:item.sold="{ item }">
                <v-btn color="accent" @click="salesDialog(item)" text icon>Sold</v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <v-row>
          <v-dialog v-model="purchasedModal" max-width="750px">
            <v-toolbar color="primary" dense dark>
              <v-toolbar-title>Purchases</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="purchasedModal = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <h2>{{ProductName}}</h2>
                  </v-col>
                  <v-col cols="12">
                    <v-data-table
                      :items-per-page="pageItems"
                      :headers="purchasesHeaders"
                      :items="purchases"
                      :search="search"
                    ></v-data-table>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of purchases -->

          <!-- sales -->
          <v-dialog v-model="salesModal" max-width="750px">
            <v-toolbar color="accent" dense dark>
              <v-toolbar-title>Sales</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="salesModal = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <h2>{{ProductName}}</h2>
                  </v-col>
                  <v-col cols="12">
                    <v-data-table
                      :items-per-page="pageItems"
                      :headers="salesHeaders"
                      :items="sales"
                      :search="search"
                    ></v-data-table>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "CompareIndex",
  data: () => ({
    search: "",
    pageItems: 100,
    TotalProfit: null,
    record: {},
    loader: false,
    menu1: false,
    menu2: false,
    purchasedModal: false,
    salesModal: false,
    ProductName: null,
    purchases: [],
    headers: [
      { text: "Product Name", value: "ProductName" },
      { text: "Total Purchased", value: "TotalPurchased" },
      { text: "Total Sales", value: "TotalSold" },
      { text: "Difference", value: "AuditAvailableQty" },
      { text: "Available Qty", value: "StockAvailableQty" },
      { text: "Deviation", value: "Difference" },
      { text: "Purchased Stock", value: "purchased" },
      { text: "Sold Stock", value: "sold" },
    ],
    purchasesHeaders: [
      { text: "Quantity", value: "Quantity" },
      { text: "Price", value: "Price" },
      { text: "Date", value: "DocDate" },
    ],
    salesHeaders: [
      { text: "Quantity", value: "Quantity" },
      { text: "Price", value: "Price" },
      { text: "Date", value: "DocDate" },
    ],
    sales: [],
    auditData: [],
  }),
  methods: {
    setStartDate(date) {
      this.record.StartDate = date;
    },
    setEndDate(date) {
      this.record.EndDate = date;
    },
    purchaseDialog(data) {
      this.ProductName = data.ProductName;
      this.purchases = data.PurchaseRecords;
      this.purchasedModal = true;
    },
    salesDialog(data) {
      this.ProductName = data.ProductName;
      this.sales = data.SoldRecords;
      this.salesModal = true;
    },
    queryData() {
      const data = this.record;
      const url = "/products-audit-report";
      this.loader = true;
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.auditData = res.ResponseData;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getSales() {
      const self = this;
      this.$store
        .dispatch("get", `/outsourced-products`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.sales = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getSales();
  },
};
</script>